import { administratorRoles } from "../config/roles";
import { dataModelTypeOptions } from "../pages/dataModel/dataModelValidators";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/data-model";

/**
 * The data models list. Paged by the search endpoint, the only read the warehouse
 * offers, and read on arrival as the legacy table did. The table has no state column.
 */
export const dataModelsListDefinition: ListDefinition = {
  path: "/data-models",
  entityName: "dwdatamodel",
  recordRoute,
  title: "Data Models",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  // Lower case: the repository reads these keys from a case-sensitive dictionary.
  filters: [
    { name: "name", label: "Name", kind: "text", width: "wide" },
    {
      name: "type",
      label: "Type",
      kind: "picklist",
      options: dataModelTypeOptions,
    },
  ],
  filterByStatus: false,
  allowAdd: true,
  addRoles: administratorRoles,
  allowStatusEdit: false,
  allowDelete: true,
  deleteRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    { key: "datamodelcategory", label: "Category", width: 200 },
    {
      key: "type",
      label: "Type",
      width: 200,
      display: "component",
      componentKey: "dataModelType",
      sortable: true,
    },
    { key: "datavalue", label: "Value", width: 200 },
    // Long text, sized as the legacy table's content-width column was.
    { key: "datadescription", label: "Description", width: 400 },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
